import HttpService from "@/services/HttpService";

const MainService = {
  async obtenerCatalogo() {
    return await HttpService.get("/operadora/getCatalogDigital");
  },
  async obtenerPorPais(pais, tipo) {
    return await HttpService.post("/operadora/getByCountry", {
      tipo: tipo,
      pais: pais,
    });
  },
  async obtenerPais(tipo, pais) {
    return await HttpService.post("/operadora/getCountries", {
      tipo: tipo,
      pais: pais,
    });
  },
  async obtenerPorRegion(tipo, region) {
    return await HttpService.post("/operadora/getByRegion", {
      tipo: tipo,
      region: region,
    });
  },
  async actualizarPaquetes(date) {
    return await HttpService.post("/operadora/updateStatus", { date: date });
  },
  async obtenerServer() {
    return await HttpService.get("/operadora/getServer");
  },

  async descargar(url, titulo) {
    return await HttpService.download("/operadora/download?url=" + url, titulo);
  },
  async obtenerUltimasOfertas() {
    return await HttpService.get("/operadora/getLastestOffers");
  },
};

export default MainService;
